import { useMutation } from "@apollo/client";
import { evictFields } from "../../../helpers/cache";
import { toast } from "react-toastify";
import { UPDATE_CUSTOMER } from "../customer.queries";
import {
  UpdateCustomerMutation,
  UpdateCustomerMutationVariables,
} from "../../../__generated__/UpdateCustomerMutation";

export const useToggleCustomerHidden = () => {
  const [mutate, { loading }] = useMutation<
    UpdateCustomerMutation,
    UpdateCustomerMutationVariables
  >(UPDATE_CUSTOMER, {
    refetchQueries: ["CustomersQuery", "CustomerQuery"],
    update(cache) {
      evictFields(cache, ["customer", "customers"]);
    },
  });

  const toggleHidden = async (id: number, hidden: boolean) => {
    if (loading) return;
    try {
      const { data } = await mutate({ variables: { id, input: { hidden } } });
      if (data?.updateCustomer?.ok) {
        toast.success(hidden ? "Le client a été masqué" : "Le client a été réaffiché");
      } else {
        toast.error(data?.updateCustomer?.error ?? "Une erreur est survenue");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  return { toggleHidden, loading };
};
